import { render, staticRenderFns } from "./viewbigpicture.vue?vue&type=template&id=73f30e40&scoped=true"
import script from "./viewbigpicture.vue?vue&type=script&lang=js"
export * from "./viewbigpicture.vue?vue&type=script&lang=js"
import style0 from "./viewbigpicture.vue?vue&type=style&index=0&id=73f30e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f30e40",
  null
  
)

export default component.exports